module.exports = __webpack_public_path__ + "static/slide-02@2x.3aabf4b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/connect/slide-02@2x.png
// module id = 200
// module chunks = 68530290604204 153456355441848